module.exports = __webpack_public_path__ + "static/img/img-zimu02.96dcf1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-zimu02.png
// module id = BomE
// module chunks = 1